import PayoutsBarChart from './PayoutsBarChart';

export default PayoutsBarChart;
